var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('new-pro-popup', {
    attrs: {
      "data-to-show": _vm.isNewProPopupDisplayed,
      "pro-to-edit": _vm.pros[_vm.indexProToEdit]
    },
    on: {
      "close": function ($event) {
        return _vm.changeStateNewProPopup(false);
      },
      "addPro": function (newValue) {
        _vm.addNewPro(newValue);
      },
      "modifyPro": function (newValue) {
        _vm.modifyPro(newValue);
      }
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "my-15 mx-10"
  }, [_vm._v("Expériences")]), _vm._v(" "), _vm.pros.length === 0 ? _c('div', [_c('h6', {
    staticClass: "mx-15 text-gray-600"
  }, [_vm._v("\n                Aucune expérience professionnelle n'a été renseignée sur votre Neopass.\n            ")]), _vm._v(" "), _c('h6', {
    staticClass: "mx-15 text-gray-600 mt-5"
  }, [_vm._v("\n                Pour mettre en avant vos expériences professionnelles, cliquer sur le bouton \"ajouter une nouvelle expérience\"\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mt-15"
  }, [_c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "bg-color-square": "bg-indigo-600",
      "icon-color": "text-white",
      "libelle": "Ajouter une nouvelle expérience",
      "uppercase": true,
      "icon": "plus-circle",
      "typeShadow": "indigo-shadow"
    },
    on: {
      "clickAction": function ($event) {
        _vm.isNewProPopupDisplayed = true;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center mt-10"
  }, [_c('illustration', {
    attrs: {
      "name": "evaluation"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm.pros.length > 0 ? _c('div', [_c('add-button', {
    staticClass: "mb-8 mx-10",
    attrs: {
      "libelle": "Ajouter une nouvelle expérience"
    },
    on: {
      "add": function ($event) {
        _vm.isNewProPopupDisplayed = true;
      }
    }
  }), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "handle": ".handle"
    },
    on: {
      "end": function ($event) {
        _vm.drag = false;
      },
      "start": function ($event) {
        _vm.drag = true;
      }
    },
    model: {
      value: _vm.form.data.pros,
      callback: function ($$v) {
        _vm.$set(_vm.form.data, "pros", $$v);
      },
      expression: "form.data.pros"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    attrs: {
      "enter-active-class": "ease-in duration-1000",
      "enter-class": "bg-indigo-300 border-0 rounded-xl",
      "enter-to-class": "bg-none border-0 rounded-xl",
      "leave-active-class": "linear duration-1000",
      "leave-class": "h-20 opacity-100",
      "leave-to-class": "h-0 opacity-0",
      "tag": "div"
    }
  }, _vm._l([].concat(_vm.pros, _vm.newPros), function (pro, i) {
    return _c('div', {
      key: 'pro' + i,
      staticClass: "grid grid-cols-10 gap-x-4 py-5 odd:bg-gray-200 items-center",
      class: pro.value.new ? ' odd:bg-opacity-25' : ' odd:bg-opacity-50'
    }, [_c('div', {
      staticClass: "col-span-2 justify-self-center handle",
      class: pro.value.new ? ' opacity-25' : ''
    }, [_c('icon', {
      staticClass: "text-indigo-600 w-5 h-5 cursor-move",
      attrs: {
        "name": "move"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-5 md:col-span-6 grid grid-cols-12 items-center"
    }, [_c('div', {
      staticClass: "col-span-2"
    }, [_vm.changedPros[pro.value.type + pro.value.value.intitule_parcours] || pro.value.new ? _c('CVNewValue', {
      attrs: {
        "old": _vm.newer.data.parcours[pro.value.type + pro.value.value.intitule_parcours],
        "right": false,
        "is-new": pro.value.new
      },
      on: {
        "change": function (newValue) {
          pro.value = _vm.replaceValues(pro.value, newValue);
          _vm.newer.data.parcours[pro.value.type + pro.value.value.intitule_parcours] = false;
        },
        "addNew": function (newValue) {
          _vm.importFromNeopass(newValue);
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-span-10",
      class: pro.value.new ? ' opacity-25' : ''
    }, [_c('p', {
      staticClass: "text-base font-normal"
    }, [_vm._v(_vm._s(pro.value.type === "Stage" ? pro.value.type + (pro.value.value.intitule_parcours ? ' - ' : '') : '') + _vm._s(pro.value.value.intitule_parcours ? pro.value.value.intitule_parcours : ''))]), _vm._v(" "), _c('p', {
      staticClass: "text-base font-light"
    }, [_vm._v("\n                                    " + _vm._s(pro.value.value.localisation_parcours ? pro.value.value.localisation_parcours + (pro.value.value.localisation_parcours && pro.value.value.structure_accueil_parcours ? " - " : "") + (pro.value.value.structure_accueil_parcours ? pro.value.value.structure_accueil_parcours : '') : "") + "\n                                ")]), _vm._v(" "), _c('p', {
      staticClass: "text-sm italic font-light"
    }, [_vm._v("\n                                    " + _vm._s(pro.value.value.debut_parcours ? new Date(pro.value.value.debut_parcours).toLocaleDateString() + ' - ' : '') + "\n                                    " + _vm._s(pro.value.value.fin_parcours ? new Date(pro.value.value.fin_parcours).toLocaleDateString() : pro.value.value.debut_parcours ? "à aujourd'hui" : '') + "\n                                ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-span-3 md:col-span-2 flex space-x-3"
    }, [_c('radio-button', {
      attrs: {
        "name": 'pro_' + i + '_display',
        "value": ((((_vm.form || {}).data || {}).pros || [])[i] || {}).isDisplayed || false
      },
      on: {
        "input": function (newValue) {
          ((((_vm.form || {}).data || {}).pros || [])[i] || {}).isDisplayed = newValue;
        },
        "loseFocus": function ($event) {
          return _vm.saveDatas();
        }
      }
    }), _vm._v(" "), !pro.fromNeopass ? _c('div', {
      staticClass: "cursor-pointer px-2 relative",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.displayMenuMore(i);
        }
      }
    }, [_c('icon', {
      staticClass: "text-pink-600",
      attrs: {
        "name": "more-vertical"
      }
    }), _vm._v(" "), _vm.menuMoreDisplayed === i ? _c('div', {
      directives: [{
        name: "click-outside",
        rawName: "v-click-outside",
        value: _vm.hideMenuMore,
        expression: "hideMenuMore"
      }],
      staticClass: "absolute text-gray-600 bg-white px-5 py-4 rounded-xl shadow-lg flex flex-col space-y-2 text-sm -right-full z-10"
    }, [_c('p', {
      staticClass: "hover:text-gray-900 cursor-pointer",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.displayModifyProPopup(i);
        }
      }
    }, [_vm._v("Modifier")]), _vm._v(" "), _c('p', {
      staticClass: "hover:text-gray-900 cursor-pointer",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.removePro(i);
        }
      }
    }, [_vm._v("Supprimer")])]) : _vm._e()], 1) : _vm._e()], 1)]);
  }), 0)], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }